import { api } from './api'

// Serialize list/search options into the /searchrooms query string. `facets`
// holds already-resolved primitives: standards/authors/types are id/label string
// arrays; updatedFrom/updatedTo are date strings.
function buildQuery({ q, cursor, limit, sort, facets, nested } = {}) {
  const params = new URLSearchParams()
  if (q) params.set('q', q)
  if (cursor) params.set('cursor', cursor)
  if (limit) params.set('limit', String(limit))
  if (sort) params.set('sort', sort)
  if (facets) {
    const { standards, authors, types, topics, updatedFrom, updatedTo } = facets
    if (standards?.length) params.set('standards', standards.join(','))
    if (authors?.length) params.set('authors', authors.join(','))
    if (types?.length) params.set('types', types.join(','))
    if (topics?.length) params.set('topics', topics.join(','))
    if (updatedFrom) params.set('updatedFrom', updatedFrom)
    if (updatedTo) params.set('updatedTo', updatedTo)
  }
  if (nested) params.set('nested', '1')
  const query = params.toString()
  return query ? `?${query}` : ''
}

// One keyset page of the current user's searchrooms. Resolves to
// { searchrooms, nextCursor, hasMore }.
export function listSearchrooms(options = {}) {
  return api.get(`/searchrooms${buildQuery(options)}`)
}

// A single searchroom (populated items). Used to rehydrate grid windows on
// reload where only the id was persisted. Resolves to the searchroom.
export function getSearchroom(id) {
  return api.get(`/searchrooms/${id}`).then((data) => data.searchroom)
}

// Create a searchroom. Expects { label, items } where items is an array of
// MongoDB ids.
export function createSearchroom(payload) {
  return api.post('/searchrooms', payload).then((data) => data.searchroom)
}

// Update a searchroom. Accepts a partial { label, items } (items is an array of
// MongoDB ids); only the provided fields change.
export function updateSearchroom(id, payload) {
  return api.patch(`/searchrooms/${id}`, payload).then((data) => data.searchroom)
}

// Delete a searchroom. Resolves to the deleted searchroom.
export function deleteSearchroom(id) {
  return api.del(`/searchrooms/${id}`).then((data) => data.searchroom)
}
